import { DefaultButton } from './Button';
import { BTN_CANCEL } from '../../../constants/testIds';
import { useTempEdgeTranslator } from '../../../Hooks/useTranslation';

const CancelBtn = ({ onCancel, ...rest }) => {
  const { tempedgeTranslator } = useTempEdgeTranslator();

  const handleCancel = () => (onCancel ? onCancel() : window.location.reload());

  return (
    <div>
      <DefaultButton data-testid={BTN_CANCEL} {...rest} onClick={handleCancel}>
        {tempedgeTranslator('com.tempedge.msg.label.cancel')}
      </DefaultButton>
    </div>
  );
};

export default CancelBtn;
